import { ReachAPI } from './ReachAPI';

/**
 * @class mq
 * @hideconstructor
 * @memberof ReachAPI
 */
ReachAPI.mq = {};

/**
 * POST Endpoint `/mq/hop/postback`
 * @param player_id
 * @param postback_id
 * @param {Object} data
 * @returns {jQuery.jqXHR}
 * @memberof ReachAPI.mq
 */
ReachAPI.mq.postHopPostback = function (player_id, postback_id, data) {
    player_id = player_id || '';
    postback_id = postback_id || '';
    data = data || {};

    var url = ReachAPI.server + '/mq/hop/postback/' + player_id;
    var params = {
        postbackid: postback_id,
        data: JSON.stringify(data),
    };

    return ReachAPI.post(url, params);
};

/**
 * POST Endpoint `/mq/hop/channel`
 * @param player_id
 * @param channel
 * @param {Object} data
 * @returns {jQuery.jqXHR}
 * @memberof ReachAPI.mq
 */
ReachAPI.mq.postHopChannelMessage = function (channel, player_id, data) {
    player_id = player_id || '';
    channel = channel || '';
    data = data || {};

    var url = ReachAPI.server + '/mq/hop/channel/';
    var params = {
        player_id: player_id,
        channel: channel,
        message: JSON.stringify(data),
    };

    return ReachAPI.post(url, params);
};
